import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id", "url", "caption", "altText", "priority", "className", "numberOfImages", "handleImageOnClick"];
import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import { IN_VIEW_CONFIG } from './constants';
const LongformGalleryImage = _ref => {
  let {
      id,
      url,
      caption,
      altText,
      priority,
      className,
      numberOfImages,
      handleImageOnClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);
  const shouldRender = priority || isIntersecting;
  const HeadComponent = priority ? Head : null;
  const sizeKey = `carousel:longform:${numberOfImages}`;
  return /*#__PURE__*/React.createElement("div", {
    ref: outerRef,
    className: `${className}`
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: "longform-gallery__images__image__container",
    "data-testid": "longform-gallery__images__image__container",
    onClick: () => handleImageOnClick(id)
  }, shouldRender && /*#__PURE__*/React.createElement(ResponsiveImage, _extends({
    sizeKey: sizeKey,
    role: "button",
    src: url,
    alt: altText,
    priority: priority,
    HeadComponent: HeadComponent
  }, props))), !!caption && /*#__PURE__*/React.createElement("div", {
    className: "longform-gallery__images__image__details",
    "data-testid": "longform-gallery__images__image__details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "longform-gallery__images__image__details__caption"
  }, caption)));
};
LongformGalleryImage.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  numberOfImages: PropTypes.number.isRequired,
  altText: PropTypes.string.isRequired,
  priority: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  handleImageOnClick: PropTypes.func.isRequired
};
export default LongformGalleryImage;
//# sourceMappingURL=LongformGalleryImage.js.map